import { PageRoute } from "..";
import * as React from "react";
import { useSelector } from "react-redux";
import { Switch, useLocation, withRouter } from "react-router-dom";

import Redirect from "components/Redirect";
import { selectIsAdmin } from "store/entities/agents";
import { selectFeatureTogglePerformanceReport } from "store/entities/license";
import { getCurrentView } from "store/views/reports/selectors";

import { AuditLog } from "./auditLog/AuditLog";
import { ReportsRoutes } from "./constants";
import GenerateReport from "./exports/GenerateReport";
import Last7Days from "./summary/Last7Days";
import { HandlingTimeByStatus } from "./tickets/HandlingTimeByStatus";
import NewTickets from "./tickets/NewTickets";
import SolvedTickets from "./tickets/SolvedTickets";
import TicketFirstResponseTime from "./tickets/TicketFirstResponseTime";
import TicketRatings from "./tickets/TicketRatings";
import TicketResolutionTime from "./tickets/TicketResolutionTime";

const ReportsRouter: React.FC = () => {
  const location = useLocation();
  const isAdmin = useSelector(selectIsAdmin);
  const currentView = useSelector(getCurrentView);
  const redirectPath = /^\/reports/g.test(location.pathname) ? `/reports/${currentView}` : null;
  const hasPerformanceReport = useSelector(selectFeatureTogglePerformanceReport);

  return (
    <Switch>
      <PageRoute path={ReportsRoutes.Last7Days} documentTitle="Last 7 days" component={Last7Days} />
      <PageRoute path={ReportsRoutes.NewTickets} documentTitle="New tickets" component={NewTickets} />
      <PageRoute
        path={ReportsRoutes.TicketSatisfaction}
        documentTitle="Ticket satisfaction"
        component={TicketRatings}
      />
      <PageRoute
        path={ReportsRoutes.FirstResponseTime}
        documentTitle="First response time"
        component={TicketFirstResponseTime}
      />
      <PageRoute path={ReportsRoutes.SolvedAndClosed} documentTitle="Solved and closed" component={SolvedTickets} />
      {hasPerformanceReport && (
        <PageRoute
          path={ReportsRoutes.HandlingTimeByStatus}
          documentTitle="Handling time by status"
          component={HandlingTimeByStatus}
        />
      )}
      <PageRoute
        path={ReportsRoutes.TicketResolutionTime}
        documentTitle="Ticket resolution time"
        component={TicketResolutionTime}
      />
      <PageRoute path={ReportsRoutes.GenerateReport} documentTitle="Generate report" component={GenerateReport} />
      {isAdmin ? <PageRoute path={ReportsRoutes.AuditLog} documentTitle="Audit log" component={AuditLog} /> : null}
      {redirectPath && <Redirect to={redirectPath} />}
    </Switch>
  );
};

export default withRouter(ReportsRouter);
